export default __webpack_public_path__ + "static/accountantsCode-56d323f7afa8a6df3a1bc29b05705ec2.png";